import { render } from "./PublicUsers.vue?vue&type=template&id=796d286a&ts=true"
import script from "./PublicUsers.vue?vue&type=script&lang=ts"
export * from "./PublicUsers.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__